module.exports = __webpack_public_path__ + "school/img/persons.9f9fae9b.png";